import type { JSX } from 'react';
import type { ProprietesDeVueCanvas } from '@taki/app-runtime';

/**
 * « SAISIE EN LIGNES » : une VUE DE FICHE Canvas du Journal (regle G23, accord
 * dans `canvas.views` de `taki.app.json`, carte dans `vuesCustom` de
 * `taki.screens.json`, chantier `fiche-suivi`).
 *
 * LES MEMES INFORMATIONS QUE LA FICHE, AUTREMENT (atelier du 26/10, section 1,
 * « Fiche en lignes ») : une saisie se relit de haut en bas, un champ par
 * ligne, le libelle a gauche et sa valeur a droite, carte par carte. Rien n'est
 * recopie NI RELU : les cartes, les libelles, les mots des choix, les noms des
 * fiches et des personnes designees, les dates et les durees sont ceux que la
 * Fiche a deja resolus pour cette fiche (`lecture`, `ProprietesDeVueCanvas`,
 * `@taki/app-runtime`). Un reglage du Studio, un champ masque, une option
 * archivee changent donc les deux vues d'un coup.
 *
 * EN LECTURE : on modifie dans la Fiche, qui reste la vue par defaut et la
 * premiere du selecteur. La vue ne dessine que la zone 5.
 */
export function VueLignes({ fiche, lecture }: ProprietesDeVueCanvas): JSX.Element | null {
  if (fiche === null || lecture === null) return null;
  return (
    <div className="mx-auto w-full max-w-[48rem] px-5 pb-12 pt-6" data-vue="timesheet.lignes">
      <h2 className="text-[1.375rem] font-semibold leading-tight text-ink-900">{lecture.titre}</h2>
      {lecture.cartes.map((carte, index) => (
        <section key={`${carte.titre}-${index}`} className="mt-8">
          <h3 className="mb-2 text-[0.8125rem] font-medium text-ink-500">{carte.titre}</h3>
          <dl className="border-t border-border-soft">
            {carte.champs.map((champ) => (
              <div key={champ.cle} className="grid grid-cols-[12rem_minmax(0,1fr)] gap-4 border-b border-border-soft py-3">
                <dt className="text-[0.875rem] text-ink-500">{champ.libelle}</dt>
                <dd className={champ.rendu === null ? 'text-[0.875rem] text-ink-400' : 'whitespace-pre-line text-[0.875rem] text-ink-900'}>
                  {champ.rendu ?? 'Non renseigné'}
                </dd>
              </div>
            ))}
          </dl>
        </section>
      ))}
    </div>
  );
}
